import '../style/Home.css';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { Container } from 'react-bootstrap';
import TraineeProfile from './TraineeProfile';
import ResultsStudy from './ResultsStudy';
import { AuthContext } from '../App';
import React from 'react';


const Trainee = () => {

    const { state: authState, dispatch: authDispatch } = React.useContext(AuthContext);
    // console.log('Load trainee results:', authState.user);
    // console.log('Number of studies: ', authState.user.studies.length);

    return (
        <Container className="container">
            <Tabs
                defaultActiveKey="trainee-profile"
                id="trainee-results-tabs"
                className="mb-3"
                variant='tabs'
            >
                <Tab eventKey="trainee-profile" key="trainee-profile" title={"Profile "+authState.user.name}>
                    <TraineeProfile user={ authState.user }  ></TraineeProfile>
                </Tab>

                {console.log('authState.user.studies', authState.user.studies)}
                {authState.user.studies && authState.user.studies.length > 0 && authState.user.studies.map((iStudy) => (
                    <Tab eventKey={iStudy.studyName} key={iStudy.studyName} title={"Study " + iStudy.studyName}>
                        <ResultsStudy 
                            eventKey={authState.user.id+iStudy.studyName+'Results'} 
                            key={authState.user.id+iStudy.studyName+'Results'} 
                            study={iStudy} user={authState.user} >

                        </ResultsStudy>
                    </Tab>
                )
                )}

            </Tabs>
        </Container>
    );
}

export default Trainee;